import { AuthLayout, SpeedmaxMark } from '../components/AuthLayout';

const ERRORS: Record<string, string> = {
  state: 'Sesi login sudah tidak berlaku atau dibuka dari tab lain. Silakan masuk lagi.',
  expired: 'Waktu login habis (lebih dari 10 menit). Silakan masuk lagi.',
  exchange: 'Speedmax ID menolak proses login. Coba lagi; jika berulang, hubungi Admin.',
  sso_error: 'Login dibatalkan atau ditolak di Speedmax ID.',
  app: 'Akun ini masuk ke aplikasi lain di Speedmax ID. Silakan masuk lagi.',
};

export function LoginPage({
  returnTo,
  error,
  loggedOut,
}: {
  returnTo?: string;
  error?: string;
  loggedOut?: boolean;
}) {
  const href = `/auth/login${returnTo && returnTo !== '/login' ? `?returnTo=${encodeURIComponent(returnTo)}` : ''}`;
  return (
    <AuthLayout>
      <section className="fn-card fn-card--pad fn-auth__card flex flex-col gap-5">
        <div className="flex items-center gap-3">
          <img className="fn-logo" src="/logo-only.png" alt="Speedmax" width={48} height={48} />
          <div>
            <div className="fn-wordmark__name" style={{ fontSize: 24 }}>
              FTTH <span>NMS</span>
            </div>
            <p className="fn-card__desc">Satu peta untuk seluruh jaringan fiber Speedmax.</p>
          </div>
        </div>

        {loggedOut && !error && (
          <div className="fn-alert fn-alert--success" role="status">
            <div className="fn-alert__body">
              <span className="fn-alert__title">Anda sudah keluar dari FTTH NMS.</span>
              <span className="fn-alert__text">
                Sesi Speedmax ID masih aktif, jadi tombol di bawah akan langsung memasukkan Anda lagi.
              </span>
            </div>
          </div>
        )}
        {error && (
          <div className="fn-alert fn-alert--danger" role="alert">
            <div className="fn-alert__body">{ERRORS[error] ?? 'Login gagal. Silakan coba lagi.'}</div>
          </div>
        )}

        <a href={href} className="fn-btn fn-btn--primary fn-btn--lg fn-btn--block">
          <SpeedmaxMark />
          Masuk dengan Speedmax ID
        </a>
        <p className="fn-hint" style={{ textAlign: 'center' }}>
          Gunakan akun Speedmax ID Anda. Hak akses diatur oleh Admin di Speedmax ID.
        </p>
      </section>
    </AuthLayout>
  );
}
